import axios from 'axios';
import { readCookie } from './utils';

const fetchClient = axios.create({
  baseURL: process.env.REACT_APP_DEFAULT_API_PATH,
  // baseURL: 'https://localhost:7111',
});

fetchClient.interceptors.request.use(function (config) {
  const roleId = readCookie('roleId');
  const username = readCookie('username');
  config.headers.roleId = roleId ? roleId : '';
  config.headers.username = username ? username : '';
  return config;
});



export default fetchClient;
